import { FC, useState } from 'react';
import { Button, Dropdown, Icons, Search } from '@silverfort/sf-components';
import { useApplicationsContext } from './context/ApplicationsContext';
import { LastAccessOptions } from '../../../common/lastAccess';
import { useGetApplicationsReport } from '../../../api/queries/useGetApplicationsReport';
import { ApplicationsOptionsMenu } from './components/ApplicationsOptionsMenu';

export const ApplicationsQueryBuilder: FC = () => {
    const { filters, sorting, updateFilter } = useApplicationsContext();

    const [searchText, setSearchText] = useState('');

    const { downloadReport, downloadingReport } = useGetApplicationsReport(filters, sorting);

    const onSearch = (text: string) => {
        setSearchText(text);

        updateFilter('name', text);
    };

    const updateLastAccess = (value?: number | Array<number>) => {
        const val = Array.isArray(value) ? value.at(0) : value;

        updateFilter('lastAccessInDays', val);
    };

    return (
        <section className="flex justify-between">
            <div className="flex gap-2">
                <Dropdown
                    key="lastAccessInDays"
                    items={LastAccessOptions}
                    onChange={updateLastAccess}
                    onRemove={updateLastAccess}
                    removable
                    selectedItems={filters.lastAccessInDays}
                    title="Last login before"
                    variant="filter"
                />
            </div>

            <div className="flex gap-2">
                <Search border onChange={onSearch} placeholder="Search" text={searchText} />

                <Button
                    iconRight={Icons.Download}
                    isLoading={downloadingReport}
                    onClick={downloadReport}
                    title="Export Applications"
                />

                <ApplicationsOptionsMenu />
            </div>
        </section>
    );
};
